import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

import { TurnstileAccessType } from '@/constants/TurnstileAccessConstants';

export interface TurnstileAccessFilterAtom {
	type: TurnstileAccessType;
	employee: string[];
	employeeStatus: string[];
	training: string[];
	jobTitle: string[];
	coordination: string[];
	management: string[];
	workstation: string[];
	pole: string[];
	board: string[];
	showAllEmployees: boolean;
}

const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;

export const turnstileAccessFilterAtom = atom<TurnstileAccessFilterAtom>({
	key: 'turnstileAccessFilterAtom',
	default: {
		type: TurnstileAccessType.Blocked,
		employee: [],
		employeeStatus: [],
		training: [],
		jobTitle: [],
		coordination: [],
		management: [],
		workstation: [],
		pole: [],
		board: [],
		showAllEmployees: false,
	},
	effects: [
		urlSyncEffect<TurnstileAccessFilterAtom>({
			refine: r.object({
				type: r.custom((value) => {
					switch (value) {
						case TurnstileAccessType.Blocked:
							return value;
						case TurnstileAccessType.InRisk:
							return value;
						case TurnstileAccessType.Exception:
							return value;
						default:
							return TurnstileAccessType.Blocked;
					}
				}),
				employee: stringArrayChecker,
				employeeStatus: stringArrayChecker,
				training: stringArrayChecker,
				jobTitle: stringArrayChecker,
				coordination: stringArrayChecker,
				management: stringArrayChecker,
				workstation: stringArrayChecker,
				pole: stringArrayChecker,
				board: stringArrayChecker,
				showAllEmployees: r.custom((value) => {
					if (typeof value === 'boolean') {
						return value;
					}
					if (typeof value === 'string') {
						return value === 'true';
					}
					return true;
				}),
			}),
			history: 'push',
		}),
	],
});
